export const Assessment_Grade_Head = [
  { field: "lead_id", headerName: "Lead ID", width: 100 },
  { field: "lead_name", headerName: "Name", width: 200 },
  { field: "lead_class", headerName: "Class", width: 150 },
  { field: "lead_mob_no", headerName: "Mobile", width: 200 },
  { field: "lead_place", headerName: "Place", width: 200 },
  { field: "lead_timestamp", headerName: "Time", width: 200 },
  { field: "oga_name", headerName: "OGA Name", width: 250 },
];
